import { Injectable } from "@angular/core";
import { IstanzaAttivitaDTO } from "../dto/istanza-attivitaDTO";

import { IstanzaAttivitaVO } from "../vo/istanza-attivitaVO";

import { MapperInterface } from "./mapper-inteface";
import { MapperProcedimento } from "./mapper-procedimento";

@Injectable({ providedIn: "root" })
export class MapperIstanzaAttivita
  implements MapperInterface<IstanzaAttivitaDTO, IstanzaAttivitaVO> {
  constructor(private procedimentoMapper: MapperProcedimento) {}

  convertVoToDto(istanzaAttivitaVO: IstanzaAttivitaVO): IstanzaAttivitaDTO {
    if (istanzaAttivitaVO != null) {
      // console.log("[MapperSettore] IstanzaAttivitaVO => IstanzaAttivitaDTO", IstanzaAttivitaVO);
      const istanzaAttivitaDTO = new IstanzaAttivitaDTO();

      istanzaAttivitaDTO.codice = istanzaAttivitaVO.codice;
      istanzaAttivitaDTO.nome = istanzaAttivitaVO.nome;
      istanzaAttivitaDTO.id = istanzaAttivitaVO.id;

      istanzaAttivitaDTO.procedimentiAssociati = this.procedimentoMapper.convertListVoToDto(
        istanzaAttivitaVO.procedimentiAssociati
      );

      // console.log("return", IstanzaAttivitaDTO);
      return istanzaAttivitaDTO || new IstanzaAttivitaDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(istanzaAttivitaDTO: IstanzaAttivitaDTO): IstanzaAttivitaVO {
    if (istanzaAttivitaDTO != null) {
      // console.log("[MapperSettore] IstanzaAttivitaDTO => IstanzaAttivitaVO", IstanzaAttivitaDTO);
      const istanzaAttivitaVO = new IstanzaAttivitaVO();

      istanzaAttivitaVO.codice = istanzaAttivitaDTO.codice;
      istanzaAttivitaVO.nome = istanzaAttivitaDTO.nome;
      istanzaAttivitaVO.id = istanzaAttivitaDTO.id;

      istanzaAttivitaVO.procedimentiAssociati = this.procedimentoMapper.convertListDtoToVo(
        istanzaAttivitaDTO.procedimentiAssociati
      );

      // console.log("[MapperSettore] fine IstanzaAttivitaDTO => IstanzaAttivitaVO", IstanzaAttivitaVO);
      return istanzaAttivitaVO || new IstanzaAttivitaVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(
    istanzaAttivitaVOList: IstanzaAttivitaVO[]
  ): IstanzaAttivitaDTO[] {
    if (istanzaAttivitaVOList != null) {
      const istanzaAttivitaDTOList = new Array<IstanzaAttivitaDTO>();
      istanzaAttivitaVOList.forEach((vo) => {
        istanzaAttivitaDTOList.push(this.convertVoToDto(vo));
      });

      return istanzaAttivitaDTOList || new Array<IstanzaAttivitaDTO>();
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    istanzaAttivitaDTOList: IstanzaAttivitaDTO[]
  ): IstanzaAttivitaVO[] {
    if (istanzaAttivitaDTOList != null) {
      // console.log("[MapperSettori] IstanzaAttivitaDTOList => IstanzaAttivitaDTOList");
      // console.log("IstanzaAttivitaDTOList", IstanzaAttivitaDTOList);
      const istanzaAttivitaVOList = new Array<IstanzaAttivitaVO>();
      istanzaAttivitaDTOList.forEach((dto) => {
        istanzaAttivitaVOList.push(this.convertDtoToVo(dto));
      });

      return istanzaAttivitaVOList || new Array<IstanzaAttivitaVO>();
    } else {
      return null;
    }
  }
}
